<template>
  <div class="product__item product__item-d">
    <div class="product__thumb fix">
      <div class="product-image w-img">
        <router-link :to="`/shop-details/${product.id}`">
          <img :src="product.image" alt="product" class="shop-thumb-img" />
        </router-link>
      </div>

      <div class="product-image__overlay-top-left ">
        <div v-if="product.quantity	== 0" class="label label--hot" data-js-product-label-hot="">
          Sold Out
        </div>
        <div v-if="product.discount_percentage" class="label label--sale" >-{{ product.discount_percentage }}%</div>
      </div>



      <div class="fe-product-actions">
        <a
          href="#"
          class="fe-product-action-btn"
          :class="{ 'is-active': isItemInWishlist(product) }"
          @click.prevent="wishlistStore.add_wishlist_product(product)"
          title="Add to Wishlist"
        >
          <i class="fas fa-heart"></i>
        </a>
        <a
          href="#"
          class="fe-product-action-btn"
          @click.prevent="handleOpenModal(`product-modal-${product.id}`, product)"
          title="Quick View"
        >
          <i class="fas fa-eye"></i>
        </a>
      </div>
    </div>
    <div class="product__content-3">
      <span v-if="product.product_code" class="fe-shop-product-code">{{ product.product_code }}</span>
      <h6 class="fe-shop-title"><router-link :to="`/product-details/${product.id}`">{{ product.title }}</router-link></h6>
      <div class="fe-shop-price-row">
        <div class="fe-shop-price-block">
          <span class="fe-shop-price-current">Rs. {{ formatPrice(product.price) }}</span>
          <div v-if="product.discount_percentage > 0" class="fe-shop-discount-line">
            <del class="fe-shop-price-was">Rs. {{ formatPrice(calculateOriginalPrice(product.price, product.discount_percentage)) }}</del>
            <span class="fe-shop-discount-tag">{{ product.discount_percentage }}% Off</span>
          </div>
        </div>
      </div>
    </div>
    <div class="product__add-cart-s text-center">
      <router-link :to="`/shop-details/${product.id}`"
        class="cart-btn d-flex mb-10 align-items-center justify-content-center w-100">
        View More Details
      </router-link>
      <!--
      <button type="button" class="wc-checkout d-flex align-items-center justify-content-center w-100"
        data-bs-toggle="modal">
         @click.prevent="handleOpenModal(`product-modal-${product.id}`, product)" :data-bs-target="`#${utilityStore.modalId}`" 
        Quick View
      </button>-->
    </div>
  </div>
</template>

<script>
import { calculateOriginalPrice } from '@/utils/utils'
import { useWishlistStore } from '@/stores/wishlistStore'
import { useCartStore } from '@/stores/useCartStore'

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      calculateOriginalPrice,
      wishlistStore: useWishlistStore(),
      cartStore: useCartStore(),
    }
  },
  methods: {
    isItemInWishlist(product) {
      return this.wishlistStore.wishlists.some((prd) => String(prd.id) === String(product.id))
    },
    isItemInCart(product) {
      return this.cartStore.cart_products.some((prd) => prd.id === product.id)
    },
    addToCart(product) {
      this.cartStore.addCartProduct(product)
    },
    handleOpenModal() {},
    formatPrice(val) {
      if (val === null || val === undefined || val === '') return '0'
      const n = Number(val)
      if (Number.isNaN(n)) return String(val)
      return n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    },
  },
}
</script>
<style scoped>
/* ─── Always-visible action buttons (wishlist + quick view) ─── */
.fe-product-actions {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 5;
}

.fe-product-action-btn {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #fff;
  color: #94a3b8;
  font-size: 14px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}

.fe-product-action-btn:hover {
  background: var(--fe-accent, #fcbe00);
  border-color: var(--fe-accent, #fcbe00);
  color: #fff;
  box-shadow: 0 4px 12px rgba(252, 190, 0, 0.3);
  transform: scale(1.1);
}

.fe-product-action-btn.is-active {
  background: var(--fe-accent, #fcbe00);
  border-color: var(--fe-accent, #fcbe00);
  color: #fff;
  box-shadow: 0 3px 10px rgba(252, 190, 0, 0.3);
}

.fe-product-action-btn.is-active:hover {
  background: var(--fe-accent-hover, #e5ac00);
  border-color: var(--fe-accent-hover, #e5ac00);
  box-shadow: 0 4px 14px rgba(252, 190, 0, 0.4);
}

/* ─── Product Code ─── */
.fe-shop-product-code {
  display: block;
  font-size: 11.5px;
  font-weight: 500;
  color: #9ca3af;
  letter-spacing: 0.02em;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ─── Product Title ─── */
.fe-shop-title {
  min-height: 40px;
  line-height: 1.4;
  margin-bottom: 10px;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.fe-shop-title a {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  text-decoration: none;
  line-height: 1.4;
  text-transform: uppercase;
}

.fe-shop-title a:hover {
  color: var(--fe-accent, #e5920a);
}

/* ─── Price Row ─── */
.fe-shop-price-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: auto;
  padding-top: 8px;
}

.fe-shop-price-block {
  flex: 1;
  min-width: 0;
}

.fe-shop-price-current {
  display: block;
  font-size: 17px;
  font-weight: 800;
  color: #e53935;
  letter-spacing: -0.01em;
  line-height: 1.3;
}

.fe-shop-discount-line {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 3px;
}

.fe-shop-price-was {
  font-size: 13px;
  font-weight: 500;
  color: #9ca3af;
  line-height: 1.3;
}

.fe-shop-discount-tag {
  font-size: 12px;
  font-weight: 700;
  color: #e53935;
  line-height: 1.3;
}

/* ─── Cart Icon Button ─── */
.fe-shop-cart-icon {
  margin-left: auto;
  margin-top: 2px;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #64748b;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  padding: 0;
  text-decoration: none;
}

.fe-shop-cart-icon:hover {
  background: var(--fe-accent, #fcbe00);
  border-color: var(--fe-accent, #fcbe00);
  color: #fff;
  box-shadow: 0 4px 12px rgba(252, 190, 0, 0.3);
  transform: translateY(-1px);
}

.fe-shop-cart-icon--active {
  background: var(--fe-accent, #fcbe00);
  border-color: var(--fe-accent, #fcbe00);
  color: #fff;
}

.fe-shop-cart-icon--active:hover {
  filter: brightness(1.08);
}

/* ─── Labels ─── */
.label--hot {
  background-color: #cc1414;
  width: 68px !important;
}

.product-image__overlay-top-left {
  align-items: flex-start;
  flex-direction: column;
  display: flex;
  position: absolute;
  top: 3px;
  left: 0px;
}

.product-image__overlay-top-left .label {
  display: flex;
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  height: 20px;
  padding: 5px;
  margin-bottom: 5px;
  align-items: center;
  position: relative;
  text-transform: uppercase;
  width: 50px;
  border-radius: 2px;
  justify-content: center;
}

.label--sale {
  background-color: #5aab19;
}

/* ─── Card Layout ─── */
.product-image {
  width: 221px;
  height: 220px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  overflow: hidden;
}

.product__item {
  height: 100%;
  min-height: 430px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product__content-3 {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  padding: 12px 16px 0;
}

.product__add-cart-s {
  margin-top: auto;
}

.product-image a {
  width: 221px;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.shop-thumb-img {
  width: 221px;
  height: 220px;
  object-fit: contain;
  object-position: center;
}

@media (max-width: 767px) {
  .fe-shop-product-code {
    font-size: 10.5px;
  }

  .fe-shop-title a {
    font-size: 12.5px;
  }

  .fe-shop-price-current {
    font-size: 15px;
  }

  .fe-shop-cart-icon {
    width: 32px;
    height: 32px;
    font-size: 13px;
  }
}
</style>